$(document).ready(function(){

    var loadingModal = $('#loading-modal').modal({
        bgClose : false,
        disableTrigger : true,
        width : 'auto-width'
    });

    if ( $.fn.paginate ) {
        //paginate team donations tables
        if ($('#team-donations').length > 0) {
            $('#team-donations').paginate();
        }

        //paginate team members tables
        if ($('.team-members-table').length > 0) {
            $('.team-members-table').paginate();
        }
    }

    if ( $('#delete-member-modal').length ) {
        var deleteMemberModal = $('#delete-member-modal').modal({
            disableTrigger : true,
            accept : function() {
                performTeamAction($('#delete-member-modal'));
                deleteMemberModal.data('qg_modal').closeModal();
            },
            decline : function() {
                deleteMemberModal.data('qg_modal').closeModal();
            }
        });

        //transfer donation property to modal when clicking on delete
        $('.action').on('click', '.delete-member', function(e) {
            e.preventDefault();
            $('#delete-member-modal').attr('data-member', $(this).attr('data-member'));
            deleteMemberModal.data('qg_modal').showModal();
        });
    }

    if ( $('#team-list-modal').length ){
        var $teamListModal = $('#team-list-modal');

        // remove hidden users from modal
        $teamListModal.find('.js-user.hide-content').remove();

        $teamListModal.modal({
            disableTrigger : true,
            width : 'search-list-modal'
        });

        var teamModal = $teamListModal.data('qg_modal');

        $('.event-content').on('click', '.trigger-team-list-modal', function(e){
            teamModal.showModal();
            $('#team-search-field').focus();

            e.preventDefault();
        });

        var $teamMembers = $teamListModal.find('.team-list-container');

        $('#team-search-field').fsearch({
            list : $teamMembers.find('.user'),
            target : 'data-name'
        });
    }

    if ( $('#supporters-list-modal').length ){
        var $supportersListModal = $('#supporters-list-modal');

        $supportersListModal.modal({
            disableTrigger : false,
            width : 'search-list-modal'
        });

        var supportersModal = $supportersListModal.data('qg_modal');

        $('.event-content').on('click', '.trigger-supporters-list-modal', function(e){
            var $container = $(this).closest('.supporters-widget'),
                $tabs = $container.find('.supporters-widget-content').clone();

            // insert cloned content into modal
            $supportersListModal.find('.supporters-list-container').html($tabs);

            var tabContainer = $tabs.find('.js-tabs').addClass('text-center').attr('data-content-toggle-container');

            // update tab IDs
            $supportersListModal.find(tabContainer).attr('id', $(tabContainer).attr('id') + '-modal').addClass('modal-overflow-list');
            $tabs.find('.js-tabs').attr('data-content-toggle-container', tabContainer + '-modal');

            // update tab link IDs
            $supportersListModal.find('.js-tab-link').each(function(){
                var target = $(this).attr('href');
                $supportersListModal.find(target).attr('id', $(target).attr('id') + '-modal');
                $(this).attr('href', '#' + $(target).attr('id') + '-modal');
            });

            // show the modal
            supportersModal.showModal();

            e.preventDefault();
        });
    }

    if ( $('#create-team-form').length ) {
        $('#create-team-form').validate();

        var createTeamModal = $('.create-team').modal({
            bgClose : false,
            accept : function() {
                var postString = buildPostString($('#create-team-form'));
                postString += '&create=1';

                $.fn.qpost({
                    url : url('join_team',[$('input[name="registration"]').val()]),
                    csrf : true,
                    data : postString,
                    success : function(data) {
                        if (data.success) {
                            window.location.href = url('team_fundraising', [data.teamId]);
                        } else {
                            Message.target = '#create-team-form';
                            Message.post(data.errors,  'error');
                        }
                    },
                    failure : function() {
                        Message.target = '#create-team-form';
                        Message.post('We were unable to create a team. Please try again.',  'error');
                    },
                });

                },
            decline : function() {
                var $fields = $('#create-team').find('#team-name');

                UI.clearErrors( $fields );
                UI.clearFields( $fields );
                $('#create-team').find('.ui-message').remove();
                createTeamModal.data('qg_modal').closeModal();
            }
        });
    }

    if ( $('#team-action').length ) {
        // Setting this up manually in case there are no triggers
        var teamActionsModal = $('#team-action').modal({
            bgClose : false,
            disableTrigger : true,
            accept : function() {
                var teamId = $('#team-action').attr('data-team-id'),
                    teamAction = $('#team-action').attr('data-team-action'),
                    registrationID = $('#team-action').attr('data-participant-id') || $('input[name="registration"]').val();

                var postString = 'teamId='+teamId;
                    postString += '&' + teamAction + '=1';
                $('#loading-modal').find('.js-loading-modal-text').text('Updating Team');
                loadingModal.data('qg_modal').showModal();

                $.fn.qpost({
                    url : url('join_team',[ registrationID ]),
                    csrf : true,
                    data : postString,
                    success : function(data) {
                        loadingModal.data('qg_modal').closeModal();
                        $('#loading-modal').find('.js-loading-modal-text').text('Saving Account Info');
                        if (data.success) {
                            if (teamAction == 'join') {
                                window.location.href = url('team_fundraising', [data.teamId]);
                            } else {
                                window.location.href = url('pfp_dashboard',[$('input[name="registration"]').val()]);
                            }
                        }
                        else if (data.errors && data.errors.length) {
                            Message.target = '.event-content:first';
                            Message.post(data.errors,  'error');
                        }
                        else {
                            Message.target = '.event-content:first';
                            Message.post('We were unable to add you to the team. Please try again.',  'error');
                        }
                    },
                    failure : function() {
                        loadingModal.data('qg_modal').closeModal();
                        $('#loading-modal').find('.js-loading-modal-text').text('Saving Account Info');
                        Message.target = '.event-content:first';
                        Message.post('We were unable to add you to the team. Please try again.',  'error');
                    },
                });
                // Function to update user status
                teamActionsModal.data('qg_modal').closeModal();
            },
            decline : function() {
                teamActionsModal.data('qg_modal').closeModal();
                $('#team-action').attr('data-team-id', '');
            }
        });

        $('.page-container').on('click', '.team-action', function( e ) {
            var teamName = $(this).attr('data-team-name'),
                teamId = $(this).attr('data-team-id'),
                teamAction = $(this).attr('data-team-action'),
                participantID = $(this).attr('data-participant-id') || null,
                actionText = teamAction == 'join' ? 'Join' : 'Leave';

            e.preventDefault();
            teamActionsModal.data('qg_modal').showModal();
            $('#team-action').attr({
                'data-team-id': teamId,
                'data-team-action': teamAction,
                'data-participant-id': participantID
            })
            .find('.team-name').text( teamName ).end()
            .find('.team-action-text').text( actionText );
        });
    }

    if ( $('.team-member-action').length ) {
        //bind the team action button
        $('.action').on('click', '.team-member-action', function(e) {
            e.preventDefault();
            performTeamAction($(this));
        });
    }

    if ( $('#team-search-field').length ) {
        var teamSearchSettings = {
            form : $('input[name="form"]').val(),
            filters : {
                classification: $('#team-search-field').attr( 'data-classification' ),
                search_category : 'teams',
                template: 'team_search_results',
                globalSearch: true,
                joinTeamSearch: true,
            },
            autoSearch : true,
            operation : $('input[name="search_type_full"]').val(),
            container : '.team-search-container',
            searchInput : '#team-search-field',
            resultContainer : '#team-results-container',
            resultTemplate : 'team_search_results', // name of the twig partial
            request : url('event_search', [$('input[name="form"]').val()]),
            saveSettings : false,
            onSuccess : function( data ) {
                noResultsCheck( data.entities, teamSearchSettings.resultContainer );
            }
        }
        //instantiate the search
        var _teamSearch = new SystemSearch( teamSearchSettings );

        function noResultsCheck( resultCount, container ) {
            if ( resultCount == 0 ) {
                $( container ).append( '<div class="grid-unit no-results-message text-center"><p class="no-margin-top">No Search Results</p></div>' )
            } else {
                $( container ).find('.no-results-message').remove();
            }
        }
    }

    if ( $('.update-team-title').length ) {
        //bind the team action button
        $('.change-name-form').on('click', '.update-team-title', function(e) {
            e.preventDefault();
            changeTeamName($(this));
        });
    }

    function changeTeamName(element) {
        var postString = 'updateTeamTitle=1&title='+encodeURI($('#update-team-name').val());
        var teamId = $('input[name="team"]').val();

        $.fn.qpost({
            url : url('team_fundraising', [teamId]),
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    //update team title and close the form
                    $('.ui-message.error').remove();
                    $('.page-team-name').text(data.teamName);
                    $('#update-team-name').val(data.teamName);
                    $('.cancel-team-name').click();
                } else {
                    Message.target = '.event-content:first';
                    Message.post(data.errors,  'error');
                }
            },
            failure : function() {
                Message.target = '.event-content:first';
                Message.post('We could not update team title. Please try again.',  'error');
            },
        });
    }

    function performTeamAction(element) {
        var action = element.attr('data-action');
        var member = element.attr('data-member');
        var postString = 'action='+action+'&member='+member;
        var teamId = $('input[name="team"]').val();

        $.fn.qpost({
            url : url('team_fundraising', [teamId]),
            csrf : true,
            data : postString,
            success : function(data) {
                if (data.success) {
                    //delete the elements that need to be replaced
                    var actionSection = element.parent();

                    //handle each action properly
                    if (action == 'promote') {
                        actionSection.children().remove();
                        actionSection.append('<a class="action-link ui-text-error-color team-member-action" href="#" data-icon="&#xe734;" data-member="'+member+'" data-action="demote">Demote</a>&nbsp;');
                        actionSection.append('<span class="ui-icon ui-text-highlight-color" data-tooltip="Team Captain" data-tooltip-position="right">&#xe6d0;</span>&nbsp;');
                        actionSection.append('<a class="action-link ui-icon ui-text-error-color delete-member" href="#" data-member="'+member+'" data-action="remove" data-tooltip="Remove Team Member" data-tooltip-position="left">&#xe6fd;</a>')
                    } else if (action == "demote") {
                        actionSection.children().remove();
                        actionSection.append('<a class="action-link ui-text-success-color team-member-action" href="#" data-icon="&#xe730;" data-member="'+member+'" data-action="promote">Promote</a>&nbsp;');
                        actionSection.append('<span class="ui-icon text-light appearance-disabled">&#xe6d0;</span>&nbsp;');
                        actionSection.append('<a class="action-link ui-icon ui-text-error-color delete-member" href="#" data-member="'+member+'" data-action="remove" data-tooltip="Remove Team Member" data-tooltip-position="left">&#xe6fd;</a>')
                    } else if (action == 'delete') {
                        //remove the row
                        var $target = $('.delete-member[data-member="'+member+'"]').parents('.data-row');
                        $target.addClass('fade-out-content');
                        setTimeout(function() {
                            $target.slideUp().delay(150).remove();
                        }, 500);
                    }
                } else {
                    Message.target = '.event-content:first';
                    Message.post('We could not perform the team member action. Please try again.',  'error');
                }
            },
            failure : function() {
                Message.target = '.event-content:first';
                Message.post('We could not perform the team member action. Please try again.',  'error');
            },
        });
    }

});